import { useTranslation } from 'react-i18next'

import { calculateFreeCancellationDate } from 'entities/kyrgyzstan/lib'

import { AllIcons } from 'shared/ui/app-icon/types'
import { InfoItem } from 'shared/ui/info-item'
import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

interface BookingDetailsAccommodation {
  typeName: string
  title: string
  onClick?: () => void
}

interface BookingDetailsCancellation {
  startDate?: string | null
  freeCancellationMinutes?: number | null
  arrivalTime?: string | null
  timezone?: string | null
}

interface BookingDetailsCardProps {
  accommodation: BookingDetailsAccommodation
  roomsCount?: number
  isRoomsCountLoading?: boolean
  cancellation?: BookingDetailsCancellation
}

export const BookingDetailsCard = ({
  accommodation,
  roomsCount,
  isRoomsCountLoading = false,
  cancellation,
}: BookingDetailsCardProps) => {
  const { t } = useTranslation()

  const freeCancellationDate = calculateFreeCancellationDate(
    cancellation?.startDate ?? undefined,
    cancellation?.freeCancellationMinutes ?? undefined,
    cancellation?.arrivalTime ?? undefined,
  )
  const hasTimezone = Boolean(cancellation?.timezone)
  const items = [
    {
      id: 'accommodation',
      icon: AllIcons.HOME,
      title: accommodation.typeName,
      subtitle: accommodation.title,
      hasArrow: true,
      onClick: accommodation.onClick,
    },
    {
      id: 'rooms',
      icon: AllIcons.DOOR_CLOSE,
      title: t('kyrgyzstan_block.booking.info.rooms.title'),
      subtitle: isRoomsCountLoading ? (
        <Skeleton
          width={24}
          height={13}
        />
      ) : (
        String(roomsCount ?? 0)
      ),
      hasArrow: false,
    },
    {
      id: 'conditions',
      icon: AllIcons.LOCK_KEY,
      title: t('kyrgyzstan_block.booking.info.conditions.title'),
      subtitle: t('kyrgyzstan_block.booking.info.conditions.subtitle'),
      hasArrow: false,
    },
    ...(freeCancellationDate
      ? [
          {
            id: 'cancellation',
            icon: AllIcons.MONEY,
            title: t('kyrgyzstan_block.booking.info.cancellation.title'),
            subtitle: t(
              hasTimezone
                ? 'kyrgyzstan_block.booking.info.cancellation.subtitle_with_timezone'
                : 'kyrgyzstan_block.booking.info.cancellation.subtitle',
              {
                date: freeCancellationDate,
                timezone: cancellation?.timezone,
              },
            ),
            hasArrow: false,
          },
        ]
      : []),
  ]

  return (
    <Paper
      padding={[0]}
      radius="16px"
    >
      <div className={s.infoList}>
        {items.map((item) => (
          <InfoItem
            key={item.id}
            className={s.infoItem}
            title={item.title}
            subtitle={item.subtitle}
            icon={item.icon}
            hasArrow={item.hasArrow}
            onClick={item.onClick}
          />
        ))}
      </div>
    </Paper>
  )
}
